import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';

import { IOItemUI, IOTypes } from '../..';
import { IOMode } from '../../IO/types';
import IODialog from '../../Modal/IO/IO';
import { Mode } from '../../../utils';

const IO = ({ io, userType, services }) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal((m) => !m);
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          {io.IOType !== IOTypes.IOType.Transfer && (IOItemUI.LocalOrINTL(io.Local))}
          {' '}
          {io.IOMode === IOMode.Simple && (
            IOItemUI.Quantity(io.items[0].Quantity)
          )}
          {' '}
          {(io.IOMode === IOTypes.IOMode.MultipleAssets
            || (io.IOType === IOTypes.IOType.Transfer && io.items.length > 1))
            ? <span className="font-weight-bold">{'{Multiple securities}'}</span>
            : IOItemUI.Symbol(io.items[0])}
          {' '}
          {IOItemUI.Account(io)}
          {' '}
          {IOItemUI.BankAccount(io)}
        </Col>
      </Row>
      <Row style={{ marginTop: '1rem', marginBottom: '-1rem' }}>
        <Col>
          <Button
            color="primary"
            onClick={toggleModal}
          >
            More Info
          </Button>
        </Col>
      </Row>
      {modal && (
        <IODialog
          open
          toggle={toggleModal}
          io={io}
          services={services}
          userType={userType}
          mode={Mode.READONLY}
        />
      )}
    </React.Fragment>
  );
};

IO.propTypes = {
  io: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
  services: PropTypes.object.isRequired,
};

export default IO;
